import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    loadedContacts: [],
    loadedHotels: [],
    user: null,
    loading: false,
    error: null
  },
  mutations: {
    createContact(state, payload) {
      state.loadedContacts.push(payload)
    },
    createHotel(state, payload) {
      state.loadedHotels.push(payload)
    },
    setUser(state, payload) {
      state.user = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },
    setLoadedContacts(state, payload) {
      state.loadedContacts = payload
    },
    setLoadedHotels(state, payload) {
      state.loadedHotels = payload
    },
    updateContact(state, payload) {
      const contact = state.loadedContacts.find(contact => {
        return contact.id === payload.id
      })
      if (payload.name) {
        contact.name = payload.name
      }
      if (payload.email) {
        contact.email = payload.email
      }
      if (payload.work_No) {
        contact.work_No = payload.work_No
      }
      if (payload.position) {
        contact.position = payload.position
      }
      if (payload.area) {
        contact.area = payload.area
      }
      if (payload.sector) {
        contact.sector = payload.sector
      }
      if (payload.mobile) {
        contact.mobile = payload.mobile
      }
      if (payload.mobile_short) {
        contact.mobile_short = payload.mobile_short
      }
      if (payload.pin1) {
        contact.pin1 = payload.pin1
      }
      if (payload.puk1) {
        contact.puk1 = payload.puk1
      }
      if (payload.pin2) {
        contact.pin2 = payload.pin2
      }
      if (payload.puk2) {
        contact.puk2 = payload.puk2
      }
      if (payload.sim) {
        contact.sim = payload.sim
      }
    }
  },
  actions: {
    loadContacts({ commit }) {
      commit('setLoading', true)
      const contacts = firebase
        .database()
        .ref('contacts')
        .once('value')
        .then(data => {
          const contacts = []
          const object = data.val() //  .val gives us access to the value of the data - not an array BUT an OBJECT

          for (let key in object) {
            contacts.push({
              id: key,
              name: object[key].name,
              position: object[key].position,
              mobile: object[key].mobile,
              mobile_short: object[key].mobile_short,
              work_No: object[key].work_No,
              email: object[key].email,
              area: object[key].area,
              sector: object[key].sector,
              pin1: object[key].pin1,
              pin2: object[key].pin2,
              puk1: object[key].puk1,
              puk2: object[key].puk2,
              sim: object[key].sim
            })
          }

          commit('setLoadedContacts', contacts)
          commit('setLoading', false)
        })
        .catch(error => {
          console.error(error)
          commit('setLoading', true)
          commit('setLoading', false) //searches a bit with the loader and then stops. I used that in order to
        })
    },
    loadHotels({ commit }) {
      commit('setLoading', true)
      const hotels = firebase
        .database()
        .ref('hotels')
        .once('value')
        .then(data => {
          const hotels = []
          const object = data.val() //  .val gives us access to the value of the data - not an array BUT an OBJECT

          for (let key in object) {
            hotels.push({
              id: key,
              name: object[key].name,
              email: object[key].email,
              mobile: object[key].mobile,
              mobile_short: object[key].mobile_short,
              landline: object[key].landline,
              area: object[key].area,
              sector: object[key].sector,
              branch: object[key].branch,
              pin1: object[key].pin1,
              pin2: object[key].pin2,
              puk1: object[key].puk1,
              puk2: object[key].puk2,
              sim: object[key].sim,
              ativity: object[key].activity
            })
          }

          commit('setLoadedHotels', hotels)
          commit('setLoading', false)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', true)
          commit('setLoading', false) //searches a bit with the loader and then stops. I used that in order to
        })
    },
    createContact({ commit }, payload) {

      console.log(payload.sim);
      
      const contact = {
        name: payload.name,
        email: payload.email,
        work_No: payload.work_No,
        position: payload.selectedPosition,
        area: payload.selectAreas,
        sector: payload.selectSectors,
        mobile: payload.mobile,
        mobile_short: payload.mobile_short,
        pin1: payload.pin1,
        pin2: payload.pin2,
        puk1: payload.puk1,
        puk2: payload.puk2,
        sim: payload.sim
      }
      //reach out to Firebase and store User
      firebase
        .database()
        .ref('contacts')
        .push(contact)
        .then(data => {
          const key = data.key

          //below (3 lines), we use key Firebase gave us, to use it as an ID AND COMMIT (add it automatically) IT to the const contact above!!
          commit('createContact', {
            ...contact, //refering to const contact
            id: key
          })
          console.log(key)
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteContact({ commit }, payload) {
      const userID = payload

      firebase
        .database()
        .ref('contacts')
        .child(userID)
        .remove()
    },
    deleteHotel({ commit }, payload) {
      const hotelID = payload

      firebase
        .database()
        .ref('hotels')
        .child(hotelID)
        .remove()
    },
    createHotel({ commit }, payload) {
      const hotel = {
        name: payload.name,
        email: payload.email,
        landline: payload.landline,
        area: payload.selectAreas,
        sector: payload.selectSectors,
        mobile: payload.mobile,
        mobile_short: payload.mobile_short,
        branch: payload.branch,
        pin1: payload.pin1,
        pin2: payload.pin2,
        puk1: payload.puk1,
        puk2: payload.puk2,
        sim: payload.sim,
        activity: payload.activity
      }
      //reach out to Firebase and store User
      firebase
        .database()
        .ref('hotels')
        .push(hotel)
        .then(data => {
          const key = data.key

          //below (3 lines), we use key Firebase gave us, to use it as an ID AND COMMIT (add it automatically) IT to the const contact above!!
          commit('createHotel', {
            ...hotel, //refering to const contact
            id: key
          })
          console.log(key)
        })
        .catch(error => {
          console.log(error)
        })
    },
    signUp({ commit }, payload) {
      commit('setLoading', true) //changes the state.loading to true - we don't care if it is successful or not. We want it to show "loading"
      commit('clearError')
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          commit('setLoading', false)
          const newUser = {
            id: user.user.uid
          }
          commit('setUser', newUser)
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
        })
    },
    signIn({ commit }, payload) {
      commit('setLoading', true) //changes the state.loading to true - we don't care if it is successful or not. We want it to show "loading"
      commit('clearError')
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          console.log(user)
          commit('setLoading', false)
          const loggedUser = {
            id: user.user.uid
          }

          commit('setUser', loggedUser)
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
        })
    },

    autoSignin({ commit }, payload) {
      commit('setUser', { id: payload.uid })
    },

    logout({ commit }) {
      firebase.auth().signOut() //used firebase signout method
      commit('setUser', null) //handles the state
      commit('setLoading', false)
    },

    clearError({ commit }) {
      commit('clearError')
    },

    editContact({ commit }, payload) {
      // commit('setLoading', true)

      const updateObj = {}

      if (payload.name) {
        updateObj.name = payload.name
      }
      if (payload.email) {
        updateObj.email = payload.email
      }
      if (payload.work_No) {
        updateObj.work_No = payload.work_No
      }
      if (payload.position) {
        updateObj.position = payload.position
      }
      if (payload.area) {
        updateObj.area = payload.area
      }
      if (payload.sector) {
        updateObj.sector = payload.sector
      }
      if (payload.mobile) {
        updateObj.mobile = payload.mobile
      }
      if (payload.mobile_short) {
        updateObj.mobile_short = payload.mobile_short
      }
      if (payload.pin1) {
        updateObj.pin1 = payload.pin1
      }
      if (payload.puk1) {
        updateObj.puk1 = payload.puk1
      }
      if (payload.pin2) {
        updateObj.pin2 = payload.pin2
      }
      if (payload.puk2) {
        updateObj.puk2 = payload.puk2
      }
      if (payload.sim) {
        updateObj.sim = payload.sim
      }
      firebase
        .database()
        .ref('contacts')
        .child(payload.id)
        .update(updateObj)
        .then(() => {
          // commit('setloading', false)
          commit('updateContact', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    }
  },

  getters: {
    loadedContacts(state) {
      return state.loadedContacts.sort((contactA, contactB) =>
        contactA.name > contactB.name ? 1 : -1
      )
    },
    loadedHotels(state) {
      return state.loadedHotels.sort((hotelA, hotelB) =>
        hotelA.name > hotelB.name ? 1 : -1
      )
    },
    loadedContact(state) {
      return conctactID => {
        return state.loadedContacts.find(contact => {
          return contact.id === conctactID
        })
      }
    },
    loadedHotel(state) {
      return hotelID => {
        return state.loadedHotels.find(hotel => {
          return hotel.id === hotelID
        })
      }
    },
    user(state) {
      return state.user
    },
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    }
  }
})
